import React from 'react'
import { RedImmobile } from '../../../types/red'

const TabMappa: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile }) => {
  const lat = immobile.lat ?? null
  const lon = immobile.lon ?? null
  const mapUrl = lat != null && lon != null
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${lon - 0.01}%2C${lat - 0.01}%2C${lon + 0.01}%2C${lat + 0.01}&layer=mapnik&marker=${lat}%2C${lon}`
    : null

  return (
    <div className="space-y-4">
      {mapUrl ? (
        <div className="border border-gray-200 rounded-xl overflow-hidden" style={{ height: 500 }}>
          <iframe
            title="Mappa immobile"
            width="100%"
            height="100%"
            frameBorder="0"
            scrolling="no"
            marginHeight={0}
            marginWidth={0}
            src={mapUrl}
            style={{ border: 0 }}
          />
        </div>
      ) : (
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-10 text-center text-gray-400">
          Nessuna coordinata impostata. Inseriscile nella scheda Anagrafica (box "Dati generali") per visualizzare la mappa.
        </div>
      )}
    </div>
  )
}

export default TabMappa
